import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class ReOrderCopiedCitationCommand extends Plugin {

  constructor(editor) {
    super(editor);
    this.refresh();
  }

  execute({ value }) {
    const editor = this.editor;
    const range = editor.model.createRangeIn(editor.model.document.getRoot());
    const foundItems = [];
    for (const item of range.getItems({ ignoreElementEnd: true })) {
      if (item.getAttribute('data-citationcount') && item.getAttribute('data-citationcount').toString() === value.parentCitationCount.toString()) {
        foundItems.push(item);
      }
    };
    let id;
    editor.model.change(writer => {
      for (let i = 0; i < foundItems.length; i++) {
        if (i == 0) {
          id = foundItems[0].getAttribute('id');
          writer.removeAttribute('data-parentcitation', foundItems[0]);
          writer.setAttribute('id', value.parentCitationId, foundItems[0])
        } else {
          if (foundItems[i].getAttribute('id') === value.parentCitationId) {
            writer.setAttribute('id', id, foundItems[i])
          }
          writer.setAttribute('data-parentcitation', value.parentCitationId, foundItems[i])
        }
      }
    });
    this.editor.execute('renumbercitations')
    this.editor.fire('reOrderRightHandPanel');
  }

  refresh() {
  }
}